<template lang='pug' src='./custom-image-swap.pug'></template>

<script>

export default {
  data () {
    return {
      hovered: false
    }
  },
  props: {
    slide: Object,
    img_placeholder: String
  }
}
</script>



// WEBPACK FOOTER //
// custom-image-swap.vue?d8d54552